import { queryOptions } from "@tanstack/react-query";
import { apiRequest } from "../../lib/api";
import type { Invite, Member } from "../../lib/api-types";
import { paths } from "../../lib/endpoints";

export const membersQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: ["members", workspaceId] as const,
    queryFn: () => apiRequest<Member[]>(paths.members(workspaceId)),
  });

export const invitesQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: ["invites", workspaceId] as const,
    queryFn: () => apiRequest<Invite[]>(paths.invites(workspaceId)),
  });

/** Turns the API's Google start URL into the app's /invite/:token page URL. */
export function inviteLinkFromApiUrl(apiUrl: string, origin: string): string {
  const token = new URL(apiUrl, origin).searchParams.get("invite");
  return token ? `${origin}/invite/${encodeURIComponent(token)}` : apiUrl;
}
